import { render, staticRenderFns } from "./myFooter.vue?vue&type=template&id=5aa19244&scoped=true&"
import script from "./myFooter.vue?vue&type=script&lang=ts&"
export * from "./myFooter.vue?vue&type=script&lang=ts&"
import style0 from "./myFooter.vue?vue&type=style&index=0&id=5aa19244&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa19244",
  null
  
)

export default component.exports